import axios from "axios";

const api = axios.create({
  baseURL: "https://cg-ai.cgsoftech.in/backend/public/api",
});

export default api;
